import {DependencyInjectId} from "@@/package/const/DependencyInjectId";
import {type ApplicationContextInterface} from "@@/package/application/applicationContext";
import {PageModel} from "~~/package/mapper/common/model/PageModel";
import {HomeExploreCardModel} from "~~/package/mapper/home/model/HomeExploreCardModel";
import type HomeApi from "~~/package/apis/home/HomeApi";
import type CustomResponse from "~~/package/types/ResponseType";
import {ArticleModel} from "~~/package/mapper/home/model/ArticleModel";

export default class HomeMapper {
    protected homeApi: HomeApi;

    constructor(context: ApplicationContextInterface) {
        this.homeApi = context.getService<HomeApi>(DependencyInjectId.HomeApi);
    }

    public async getArticleList(page: number, size: number, type: string, lang: string): Promise<PageModel<ArticleModel>> {
        const response: CustomResponse<PageModel<ArticleModel>> = (await this.homeApi.getArticleList(page, size, type, lang)).data;
        const pageData = PageModel.create(response.data);
        pageData.data = pageData.data.map(article => ArticleModel.create(article));
        return pageData;
    }

    public async getArticle(params: {id?: number, link?: string}): Promise<ArticleModel> {
        const response: CustomResponse<ArticleModel> = (await this.homeApi.getArticle(params)).data;
        return ArticleModel.create(response.data);
    }
}
